import { tryFetch, IResponse } from "./FetchAPI";
import { getTokenOrDefault } from "./Storage";

export const processPayment = async (requestId: string): Promise<IResponse> => {
  try {
    const token = getTokenOrDefault();

    const res: IResponse = await tryFetch({
      url: "/sec/ticket-orders",
      method: "POST",
      token,
      payload: {
        request_id: requestId, 
      },
    });

    return res;
  } catch (error) {
    return {
      error: "Payment request failed",
      data: null,
      errors: null,
      role: null,
      id: null,
      permissions: null,
      is_success: false,
      status_code: 500,
    };
  }
};
